import { Filters } from "@volt_developers/components";

import { Optional, Scalar } from "hooks/query";
import { useActive } from "hooks/useActive";

export type Params<K extends string = string> = Record<
  K,
  Optional<Scalar[]> | Optional<Scalar>
>;

export function useFilters<FiltersModel extends Params<string>>() {
  const { isActive, toggleActive } = useActive();
  const {
    isActive: isConfirmationModalActive,
    toggleActive: toggleConfirmationModalActive,
  } = useActive();

  const {
    handleApplyFilters,
    setDefaultFilters,
    setInitialFilters,
    areFiltersInitialAndDefaultDifferent,
    areFiltersTheSameAsInitial,
  } = Filters.useFiltersContext<FiltersModel>();

  const handleReset = () => {
    toggleActive();
    setDefaultFilters();
  };

  const handleCloseConfirmationModal = () => {
    toggleConfirmationModalActive();
  };

  const handleApply = () => {
    handleApplyFilters();
    toggleActive();
  };

  const handleConfirm = () => {
    handleApply();
    toggleConfirmationModalActive();
  };

  const handleClose = () => {
    if (!areFiltersTheSameAsInitial) {
      toggleConfirmationModalActive();
    } else {
      toggleActive();
    }
  };

  const closeAllFiltersPopup = () => {
    setInitialFilters();
    toggleConfirmationModalActive();
    toggleActive();
  };

  const handleClickAway = () => {
    if (!areFiltersTheSameAsInitial) {
      toggleConfirmationModalActive();
    } else {
      toggleActive();
    }
  };

  return {
    isActive,
    toggleActive,
    handleClickAway,
    areFiltersTheSameAsInitial,
    areFiltersInitialAndDefaultDifferent,
    handleApply,
    handleClose,
    handleCloseConfirmationModal,
    isConfirmationModalActive,
    closeAllFiltersPopup,
    handleConfirm,
    handleReset,
  };
}
